<template>
    <Catalogs
      title="Тип расходов объекта"
      create-text="Новый"
      :fetch-data="fetchData"
      :fields="fields"
      :route-create="'LocationCostTypeAdd'"
      :route-edit="'LocationCostTypeEdit'"
      :route-view="'LocationCostTypeView'"
      :route-path="'/location_cost_types'"
      :can-edit="canEditLocationCostTypeCatalogs()"
    />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "LocationCostTypes",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'location-cost-type-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-cost-type-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getLocationCostTypes(data);
    },
    canEditLocationCostTypeCatalogs() {
      return this.hasPermission([PERM.CATALOG_LOCATION_COST_TYPE_EDIT]);
    }
  }
}
</script>

<style >
.location-cost-type-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.location-cost-type-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LocationCostTypes/LocationCostTypes.vue